import { Material } from '@/app/entities/Material'
import { Dialog } from '@/view/components/ui/dialog'
import { memo, ReactNode, useState } from 'react'
import { MaterialForm } from './MaterialForm'
import { MaterialGroupItem as MaterialGroupItemComponent } from './MaterialGroupItem'

export interface MaterialGroupProps {
  label: ReactNode
  materials: Material[]
}

const MaterialGroupItem = memo(MaterialGroupItemComponent)

export const MaterialGroup = ({ label, materials }: MaterialGroupProps) => {
  const [selectedMaterial, setSelectedMaterial] = useState<Material | null>(
    null,
  )

  const handleSelectMaterial = (material: Material) => {
    setSelectedMaterial(material)
  }

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      setSelectedMaterial(null)
    }
  }

  return (
    <div className="mb-4 flex flex-col gap-4">
      {label}
      <ul className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {materials?.map((material) => (
          <>
            <MaterialGroupItem
              key={material?._id}
              material={material}
              onClick={() => handleSelectMaterial(material)}
            />
          </>
        ))}
        <Dialog open={!!selectedMaterial} onOpenChange={handleOpenChange}>
          {selectedMaterial && (
            <MaterialForm
              material={selectedMaterial}
              onSucess={() => handleOpenChange(false)}
            />
          )}
        </Dialog>
      </ul>
    </div>
  )
}
